import React from 'react'
import { ThemeProvider } from '@mui/material'
import customTheme from './styles/mui_theme'
import Routes from './Routes'
import { StyledEngineProvider } from '@mui/material/styles'
import { BrowserRouter } from 'react-router-dom'
import './assets/fonts/Rubik-Regular.ttf'
import './assets/fonts/Rubik-Bold.ttf'
import './assets/fonts/Rubik-Light.ttf'

function App () {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={customTheme}>
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default App
